export default {
  lists(state) {
    return state.lists;
  },

  listFind(state, listId) {
    var lists = state.lists;
    return lists.find((list) => list._id === listId);
  },

  getMailjetCamp(state) {
    if (state.lists.lenght <= 0) {
      state.lists = JSON.parse(localStorage.getItem("campaignsMJ")) || [];
    }
    return JSON.parse(localStorage.getItem("campaignsMJ")) || [];
  },
};
